export default "__VITE_ASSET__IhyLCOwM__"